import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/General/PhoneNumber/phoneNumber.container"
    ).then((module) => ({
        default: module.PhoneNumberContainer
    }))
);
